import React from "react";

const MapPin = props => {
  return (
    <div className="custom-banner-text" style={props.style}>
      <div className="custom-icon-set">
        <div
          onMouseOver={() => props.setActive(true)}
          onMouseOut={() => props.setActive(false)}
          onClick={props.onClick}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="raw1"
            viewBox="13 8 38 50"
            className={
              "icon" +
              (props.active ? " active" : "") +
              (!props.active && props.atleastOneActive ? " dim" : "")
            }
          >
            <defs>
              <linearGradient
                id="b"
                x1="992.183"
                x2="1019.298"
                y1="516.081"
                y2="545.959"
                gradientTransform="translate(-625.812 154.938) scale(.54252)"
                gradientUnits="userSpaceOnUse"
                xlinkHref="#a"
              />
              <linearGradient id="a">
                <stop offset="0" stopColor="#27166d" />
                <stop offset="1" stopColor="#7e65c9" />
              </linearGradient>
            </defs>
            <g transform="translate(335 -1642.95) scale(3.77953)">
              <path
                fill="url(#b)"
                stroke="#fff"
                strokeWidth="0.5"
                d="m -80.168755,437.69457 c -2.191879,0 -3.96875,1.77686 -3.96875,3.96875 0,1.74766 2.523351,5.58622 3.546037,7.07037 0.230644,0.33473 0.614795,0.33471 0.845426,0 1.022671,-1.48412 3.546037,-5.32269 3.546037,-7.07037 0,-2.19189 -1.776869,-3.96875 -3.96875,-3.96875 z m 0,1.85208 a 2.1166665,2.1166665 0 0 1 2.116667,2.11667 2.1166665,2.1166665 0 0 1 -2.116667,2.11667 2.1166665,2.1166665 0 0 1 -2.116667,-2.11667 2.1166665,2.1166665 0 0 1 2.116667,-2.11667 z"
              />
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default MapPin;
